/// <reference types="emscripten" />
/** Above will import declarations from @types/emscripten, including EmscriptenModule etc. */

import { AutoResource } from './AutoResource';
import type { IDisposable } from './IDisposable';

export class WasmBuffer implements IDisposable {
  private readonly _autoPtr: AutoResource<number>;

  private _size: number;

  public constructor(module: EmscriptenModule, sizeInBytes: number) {
    this._autoPtr = new AutoResource(module._malloc(sizeInBytes), (ptr) => module._free(ptr));
    this._size = sizeInBytes;
  }

  public dispose(): void {
    this._size = 0;
    this._autoPtr.dispose();
  }

  public get size(): number {
    return this._size;
  }

  public get ptr(): number {
    return this._autoPtr.get();
  }
}
